"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pluralize_1 = require("pluralize");
var singular = function (value) { return pluralize_1.singular(value); };
exports.default = singular;
